import React, { Component } from "react";
import {
  Button,
  FormControl,
  ControlLabel,
} from "react-bootstrap";

import SwaggerAPI from "../api/SwaggerAPI";
import SwaggerEditor from "swagger-editor";
import queryString from "query-string";
import { SpecUpdateListenerPlugin, EditorMetadataPlugin } from './swagger-edit/plugins';

import "../css/SwaggerEdit.css";

class SwaggerEdit extends Component {
  state = {
    groupId: null,
    swagger: null,
    editor: null,
    message: ""
  };

  componentDidMount() {
    const { groupId, swaggerId } = queryString.parse(this.props.location.search);
    SwaggerAPI.getSwagger(groupId, swaggerId).then(swagger => {
      const editor = SwaggerEditor({
        dom_id: "#swagger-editor-container",
        plugins: [SpecUpdateListenerPlugin, EditorMetadataPlugin],
        requestInterceptor: function (request) {
          request.headers = request.headers || {};
          if (request.loadSpec) {
            request.headers.Authorization = "Bearer " + localStorage.getItem("access_token");
          }
          return request;
        }
      });
      editor.specActions.updateSpec(swagger.content)

      this.setState({
        swagger,
        editor,
        groupId,
        swaggerName: swagger.name
      });
    });
  }

  onSwaggerNameChange = (event) => {
    event.preventDefault();
    this.setState({ swaggerName: event.target.value });
  }

  saveSwagger = () => {
    if (!this.state.swagger) {
      return;
    }

    const { contentString } = this.state.editor.getEditorMetadata();
    const swagger = { content: contentString };


    // Save the name only if it has been updated
    if (this.state.swaggerName !== this.state.swagger.name) {
      SwaggerAPI.updateSwagger(
        this.state.groupId,
        this.state.swagger.id,
        { name: this.state.swaggerName }).then(newSwagger => {
          this.setState({
            swaggerName: newSwagger.name,
            swagger: newSwagger,
            message: "   Swagger updated!"
          })
        })
    }

    // Save the swagger if the text has changed
    if (contentString !== this.state.swagger.content) {
      SwaggerAPI.saveSwagger(
        this.state.groupId,
        this.state.swagger.id,
        swagger
      )
        .then(data => {
          this.setState({
            message: "   Swagger updated!"
          });

          // Remove the message after 5 seconds
          setTimeout(() => {
            this.setState({
              message: ""
            });
          }, 5000);
        })
        .catch(err => {
          this.setState({
            message: err
          });
        });
    }
  }

  goBack = () => {
    this.props.history.goBack();
  }

  render() {
    return (
      <div>
        <div className="swagger-editor-topbar black-bg">
          <Button className="left" onClick={this.goBack}>Back</Button>
          <Button bsStyle="success" className="right" onClick={this.saveSwagger}>Save</Button>
          <FormControl 
            className="right name-input"
            onChange={this.onSwaggerNameChange}
            value={this.state.swaggerName} />
          <ControlLabel className="right name-label">Name</ControlLabel>
          <div className="right message-text">{this.state.message}</div>
        </div>
        <div id="swagger-editor-container" />
      </div>
    );
  }
}

export default SwaggerEdit;



// WEBPACK FOOTER //
// ./src/components/SwaggerEdit.js